import React, { useState, useRef, useEffect } from "react";
import { Container } from "react-bootstrap";
import * as styles from "./styles.mod.scss";
import Filters from "src/assets/svgs/filters.svg";
import locale from "locales";
import RecipeCard from "./recipe-card";


const CategoryRecipes = ({ recipes, template, primaryFilters, secondaryFilters, section }) => {
  const [open, setOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [disabledTags, setDisabledTags] = useState([]);
  const [openMobile, setOpenMobile] = useState(false);
  const [filteredRecipes, setFilteredRecipes] = useState(recipes);
  const [initialDisabledTags, setInitialDisabledTags] = useState([]);
  const modalRef = useRef(null);
  const allFiltersNotFiltered = primaryFilters?.concat(secondaryFilters);
  const filtersWithNoRecipes = [];
  const recipesTranslation = locale?.pages?.recipes;

  useEffect(() => {
    allFiltersNotFiltered?.forEach((filter) => {
      const hasRecipe = recipes.some((recipe) => {
        return recipe?.filters?.some((fil) => fil?.title === filter?.title);
      });

      if (!hasRecipe) {
        filtersWithNoRecipes.push(filter?.title);
      }
    });

    setInitialDisabledTags(filtersWithNoRecipes);
    setDisabledTags(filtersWithNoRecipes);
  }, []);


  const filterByFilters = (filter) => {
    const updatedFilters = updateFiltersArray(filter);
    const filtered = filterRecipes(updatedFilters);

    setSelectedFilters(updatedFilters);

    if (recipeWithTagExists(filter)) {
      setFilteredRecipes(filtered);
    }

    const filtersWithNoRecipes = findFiltersWithNoRecipes(filtered);

    setDisabledTags(filtersWithNoRecipes);
  };

  const updateFiltersArray = (filter) => {
    const updatedFilters = [...selectedFilters];
    const filterTitle = filter?.title;

    if (updatedFilters.includes(filterTitle)) {
      updatedFilters.splice(updatedFilters.indexOf(filterTitle), 1);
    } else {
      updatedFilters.push(filterTitle);
    }

    return updatedFilters;
  };

  const filterRecipes = (updatedFilters) => {
    const enabledSecondaryFilters = [];
    return recipes.filter((recipe) => {
      const tags = recipe?.filters?.map((tag) => tag?.title) || [];
      const hasAllSelectedFilters = updatedFilters.every((selectedTag) => tags.includes(selectedTag));

      if (hasAllSelectedFilters) {
        const secondaryFilters = recipe?.filters?.filter((tag) => !updatedFilters.includes(tag?.title))?.map((tag) => tag?.title) || [];
        enabledSecondaryFilters.push(...secondaryFilters);
        return true;
      }

      return false;
    });
  };

  const recipeWithTagExists = (filter) => {
    return recipes?.some((recipe) => recipe?.filters?.some((tag) => tag?.title === filter?.title));
  };

  const findFiltersWithNoRecipes = (filteredRecipes) => {
    const filtersWithNoRecipes = [];
    allFiltersNotFiltered.forEach((filter) => {
      const hasRecipe = filteredRecipes.some((recipe) => recipe?.filters?.some((fil) => fil?.title === filter?.title));

      if (!hasRecipe) {
        filtersWithNoRecipes.push(filter?.title);
      }
    });

    return filtersWithNoRecipes;
  };


  const handleChange = (event) => {
    setIsChecked(event?.target?.checked);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!modalRef?.current?.contains(event?.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
  }, [modalRef, modalRef]);



  const clearFilters = () => {
    setFilteredRecipes(recipes);
    setIsChecked(false);
    setSelectedFilters([]);
    setDisabledTags(initialDisabledTags);
  };

  const renderSecondaryFilters = () => (
    <div className={styles.secondaryFilters}>
      <div ref={modalRef}>
        <p className={`${styles.text} ${styles.filterIcon}`} onClick={() => setOpen(!open)}>
          <Filters /> {recipesTranslation?.moreFilters}
        </p>
        {open && (
          <div className={styles.secondaryFiltersBox}>
            <div className={styles.secFilterItems}>
              {secondaryFilters?.map((filter, i) => (
                <label key={i} className={`${styles.secFilter} ${disabledTags.includes(filter?.title) && styles.disabledFilter}`}>
                  <input
                    type="checkbox"
                    className={`${styles.customCheckbox} ${selectedFilters.includes(filter?.title) && styles.activeFilter}`}
                    onClick={() => {
                      filterByFilters(filter);
                      handleChange();
                    }}
                    name={filter.title}
                    value={filter.title}
                    checked={isChecked}
                  />
                  <span>{filter.title}</span>
                </label>
              ))}
            </div>
            <div className={styles.filtersSummary}>
              <p onClick={clearFilters} className={styles.clearFilters}>{locale.cart.remove}</p>
              <p>{selectedFilters?.length} {locale.pages.recipes.filtersUsed}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  const renderMobileFilters = () => (
    <div className={styles.mobileFilters}>
      <p className={`${styles.text} ${styles.filterIcon}`} onClick={() => setOpenMobile(true)}>
        {recipesTranslation?.moreFilters} <Filters />
      </p>
      {openMobile && (
        <div className={styles.secondaryFiltersBox}>
          <div>
            <div className={styles.removeCloseFilters}>
              <p onClick={clearFilters} className={styles.clearFilters}>{locale?.cart?.remove}</p>
              <p onClick={() => setOpenMobile(false)} className={styles.closeMobileBox}>X</p>
            </div>
            <div className={styles.secFilterItems}>
              {allFiltersNotFiltered?.map((filter, i) => (
                <button
                  className={`${styles.prFilter} ${selectedFilters.includes(filter?.title) && styles.activeFilter} ${disabledTags.includes(filter?.title) && styles.disabledFilter}`}
                  onClick={() => filterByFilters(filter)}
                  key={i}
                >
                  {filter?.title}
                </button>
              ))}
            </div>
            <div className={styles.filtersSummary}>
              <p onClick={() => setOpenMobile(false)}>{selectedFilters?.length} {locale.pages.recipes.filtersUsed}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );


  return (
    <div className={styles.recipesCategorySection}>
      <Container id="all-recipes">
        {template == "all-recipes" &&
          <>
            <h2>{recipesTranslation?.discoverAllRecipes}</h2>
            <div className={styles.categoriesFilters}>
              <div className={styles.categories}>
              </div>
              <div className={styles.primaryFilters}>
                {primaryFilters?.map((filter, i) => (
                  <button
                    className={`${styles.prFilter} ${selectedFilters.includes(filter?.title) && styles.activeFilter} ${disabledTags.includes(filter.title) && styles.disabledFilter
                      }`}
                    onClick={() => filterByFilters(filter)}
                    key={i}
                  >
                    {filter?.title}
                  </button>
                )
                )}
              </div>
              {renderSecondaryFilters()}
              {renderMobileFilters()}
            </div>
          </>}
        <RecipeCard recipes={filteredRecipes} sesction={section} />
      </Container>
    </div>

  );
};

export default CategoryRecipes;
